import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
/**
 * GameBackgroundProperties.ts
 */
export class GameBackgroundProperties extends AbstractViewProperties {
    constructor() {
        super();
    }
    equals(other) {
        return false;
    }
}
//# sourceMappingURL=GameBackgroundProperties.js.map